module Meevo.Plugins.Egifts {

    export class EgiftsAnnouncementsSection extends Meevo.Components.CommonClasses.SettingsSectionBase {

        selected() {
            super.selected();
            this.contextParams.addInteropParams({ id: 'interop:egift', isInterop: true, targetRoute: 'egift-settings/announcements' });
        }

    }
}